// extracted by mini-css-extract-plugin
export var body = "styles-module--body--1YD3L";
export var border = "styles-module--border--IqC4k";
export var caption = "styles-module--caption--czxsw";
export var captionMobile = "styles-module--caption-mobile--vftVE";
export var grid = "styles-module--grid--cTJ7Q";
export var image = "styles-module--image--Xdd1u";
export var isCircle = "styles-module--is-circle--CI91b";
export var text = "styles-module--text--kkpcL";